import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { guideArticles } from "../../content/guide/articles";

export const SITE_URL = "https://platform98.com";

const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

// Pages search engines may list; the others (sign in, ordering steps,
// client and staff spaces) are kept out of their results
export const PUBLIC_PATHS = [
  "/",
  "/formalities",
  "/pricing",
  "/faq",
  "/guide",
  ...guideArticles.map((article) => `/guide/${article.slug}`),
  "/privacy-policy",
  "/terms-and-conditions",
];

// Only the production site is indexed, never the test site
const isProductionSite = () =>
  typeof window !== "undefined" &&
  window.location.hostname.replace(/^www\./, "") === "platform98.com";

// Title, description and sharing preview of a public page
function Seo({ title, description, path, image = DEFAULT_IMAGE }) {
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;

  // The default tags of index.html (read by link previews, which do not run
  // the site) would otherwise be listed twice once this page sets its own
  useEffect(() => {
    document
      .querySelectorAll("[data-default-seo]")
      .forEach((element) => element.remove());
  }, []);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Platform98" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

// Keeps private pages and the test site out of search results
export function RouteRobots() {
  const { pathname } = useLocation();
  const indexable =
    isProductionSite() &&
    PUBLIC_PATHS.includes(pathname.replace(/\/$/, "") || "/");

  return (
    <Helmet>
      <meta
        name="robots"
        content={indexable ? "index, follow" : "noindex, nofollow"}
      />
    </Helmet>
  );
}

export default Seo;
